import { createSSRApp } from 'vue';
import OrderLookup from '@order-lookup/order-lookup.vue';
import type { PageData } from '@order-lookup/types/index.mts';

export default function createApp(props: PageData) {
  const app = createSSRApp(OrderLookup, props);
  return { app };
}
